import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createWorld } from "../../../actions/mods_factory/worldsActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, WorldInterface } from "../../../store/mods_factory/worldsSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const newParams   = useAppSelector(state => state.modsFactory.worlds.newParams);
  const error       = useAppSelector(state => state.modsFactory.worlds.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: WorldInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createWorld(data));

    if (createWorld.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-world'>
        <h6 className="v-content-label">Create Map</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
